import { UIHeading2 } from '@cian/ui-kit/typography';
import cn from 'classnames';
import * as React from 'react';

import * as styles from './styles.css';
import { Discount } from '../Discount';

interface IPriceProps {
  className?: string;
  /* Цена (с учетом скидки, если скидка есть) */
  price: string;
  /* Цена до применения скидки */
  originalPrice?: string | null;
  /* Размер скидки в % */
  discountPercent?: string | null;
}

export const Price = ({ className, price, originalPrice, discountPercent }: IPriceProps) => {
  const showDiscount = originalPrice && discountPercent;

  return (
    <div className={cn(styles['price-container'], className)}>
      <UIHeading2 data-testid="price">{price}</UIHeading2>
      {showDiscount && (
        <div className={styles['discount']} data-testid="discount">
          <Discount originalPrice={originalPrice} discountPercent={discountPercent} />
        </div>
      )}
    </div>
  );
};
